import { render, staticRenderFns } from "./Stairs.vue?vue&type=template&id=df89c2c6"
import script from "./Stairs.vue?vue&type=script&lang=js"
export * from "./Stairs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports